import { fontstyle2 } from "./utils/fonts";

const Footer = () =>{
    return(
        <div className="flex flex-col items-center gap-4 mb-10 text-center" style={fontstyle2}>
            <p>30lmas09@gmail.com</p>
            <p>&copy; 2022 projectmarketplace | All rights reserved</p>
        </div>
    )
}

export default Footer;